import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { BlogSection } from "@/data/blogPosts";

const BlogFAQ = ({ items }: { items: NonNullable<BlogSection["faqItems"]> }) => (
  <Accordion type="multiple" className="not-prose space-y-4">
    {items.map((item, index) => (
      <AccordionItem key={index} value={`faq-${index}`} className="blog-faq-item rounded-lg border border-border px-6 transition-colors motion-reduce:transition-none">
        <AccordionTrigger className="blog-faq-trigger group gap-4 py-6 text-left text-lg font-medium text-foreground hover:no-underline [&>svg]:hidden">
          <span>{item.question}</span>
          <span aria-hidden="true" className="blog-faq-icon flex h-6 w-6 shrink-0 items-center justify-center text-2xl leading-none">
            <span className="group-data-[state=open]:hidden">+</span>
            <span className="hidden group-data-[state=open]:inline">−</span>
          </span>
        </AccordionTrigger>
        <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
          <div dangerouslySetInnerHTML={{ __html: item.answer }} />
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default BlogFAQ;